import { Params } from 'react-router-dom'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function replacePath(
  path: string,
  params: Readonly<Params<string>>,
  query?: Record<string, string | undefined>
): string {
  Object.keys(params).forEach((param) => {
    if (path.includes(`:${param}`)) {
      path = path.replace(`:${param}`, params[param]!)
    }
  })

  path = replaceKeysWithEmptyString(path)

  const queryString = buildQueryString(query)

  if (!queryString) return path

  if (path.endsWith('?')) {
    // If path already ends with '?', just append the query string without its '?'
    return path + queryString.slice(1)
  } else if (path.includes('?')) {
    // If path already has a query string, append with '&'
    return path + '&' + queryString.slice(1)
  } else {
    // Otherwise, add the query string with '?'
    return path + queryString
  }
}

function buildQueryString(query?: Record<string, string | undefined>): string {
  if (!query) return ''

  const filteredEntries: [string, string][] = Object.entries(query).filter(
    (entry): entry is [string, string] => typeof entry[1] === 'string'
  )

  const queryString = new URLSearchParams(filteredEntries).toString()

  return queryString ? `?${queryString}` : ''
}

// replace all missing :params with empty string
function replaceKeysWithEmptyString(input: string): string {
  return input.replace(/:[^/?]+/g, '')
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export function capitalizeFirstLetter(text: any) {
  if (typeof text !== 'string' || text.length === 0) {
    return ''
  }
  return text.charAt(0).toUpperCase() + text.slice(1)
}
